// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"30":"6c5c11cd","310":"94434468"}[chunkId] + ".css";
};